// extracted by mini-css-extract-plugin
export default {"container":"MyPageScreen_container__Ko29W","info":"MyPageScreen_info__otFUE","select":"MyPageScreen_select__dWDt2"};